import { Component } from '@angular/core';
import { AdminService } from "@modules/private/admin/data/services/view/admin.service";
import { ADMIN_COLUMNS } from "@modules/private/admin/data/constants/admin.constants";
import { ConfirmationService, MessageService } from "primeng/api";
import { ApiAdminService } from '../../data/services/api/api-admin.service';
import { ACTIONS } from '../../data/constants/admin.constants';

@Component({
  selector: 'app-admin-admins',
  templateUrl: './admin-admins.component.html',
  styleUrls: ['./admin-admins.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class AdminAdminsComponent {
  columns = ADMIN_COLUMNS
  createEntity = false
  additionalMainActions = [
    { label: 'Nuevo admin', icon: 'fa-solid fa-square-plus', action: 'CREATE' }
  ]
  actions = ACTIONS

  constructor(
    public apiAdminService: ApiAdminService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    public adminService: AdminService,
  ) {
  }

  showSuccessMessage(message: string) {
    this.messageService.add({ severity: 'success', summary: 'Éxito', detail: message });
  }

  showErrorMessage(message: string) {
    this.messageService.add({ severity: 'error', summary: 'Error', detail: message });
  }

  hideDialog() {
    this.createEntity = false;
  }

  mainActions(flow: string) {
    switch (flow) {
      case 'CREATE':
        this.adminService.newEntity()
        this.createEntity = true
        break;
      default:
        console.log(flow)
        break;
    }
  }

  actionMethods(data: {event: any, action: string, data: any}) {
    switch (data.action) {
      case 'EDIT':
        this.adminService.formMethod = 'EDIT'
        this.adminService.admin = data.data
        this.adminService.newEntity()
        this.createEntity = true
        break;
    }
  }

  saveForm() {
    const data = this.adminService.entity.value

    if (this.adminService.formMethod === 'CREATE') {
      this.apiAdminService.create(data).subscribe((r: any) => {
        if (r?.error) { this.showErrorMessage(r.msg || 'No se pudo crear el usuario'); return }
        this.hideDialog()
        this.showSuccessMessage(`El usuario ${data.names} ha sido creado`)
      })
      return
    }

    //! Quitar a alguien del Comité no lo saca de las reuniones abiertas donde ya figura como
    //! votante: ahí dejará de poder votar y el quorum —la mitad de los seleccionados— puede
    //! volverse inalcanzable hasta que Legal reajuste la lista de votantes. Por eso se avisa.
    if (this.adminService.admin?.isCommitteeMember && !data.isCommitteeMember) {
      this.confirmationService.confirm({
        header: 'Quitar del Comité',
        icon: 'fa-solid fa-triangle-exclamation',
        message: `${this.adminService.admin.names} dejará de ser miembro del Comité. Si está seleccionado como votante en una reunión abierta, Legal tendrá que reajustar esa lista para poder cerrarla.`,
        accept: () => this.updateAdmin(data)
      })
      return
    }

    this.updateAdmin(data)
  }

  private updateAdmin(data: any) {
    this.apiAdminService.update(this.adminService.admin._id, data).subscribe((r: any) => {
      if (r?.error) { this.showErrorMessage(r.msg || 'No se pudo actualizar el usuario'); return }
      this.hideDialog()
      this.showSuccessMessage(`El usuario ${this.adminService.admin.names} ha sido actualizado`)
    })
  }
}
